module.exports = "/_next/static/images/info-40487bb757f5a61023c02eba87000df9.svg";